import { render, staticRenderFns } from "./Teeth.vue?vue&type=template&id=3a6aebfc&"
import script from "./Teeth.vue?vue&type=script&lang=js&"
export * from "./Teeth.vue?vue&type=script&lang=js&"
import style0 from "./Teeth.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports